<template>
    
    <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Keluhan dan Analisa
            </h4>
          </md-card-header> -->
          <md-card-content>
            <autoextra v-if="keluhan.length == 0">
              <div class="md-layout">
                <div class="md-layout-item" style="margin-top:50px; margin-bottom:50px;">
                  <md-content>
                    <h3 style="color:brown; text-decoration:underline; text-align:center;">Tidak Ada Keluhan</h3>
                  </md-content>
                </div>
              </div>
            </autoextra>
            <autoextra :collection="keluhan" v-slot="{item,last,index}" v-if="keluhan.length != 0">
              <div class="columns" v-if="!last" :class="{last: last}">
                <label class="label">{{last ? 'New ' : ''}}Keluhan dan Analisa {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Keluhan</label>
                      <md-input  v-model="item.keluhan" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Analisa</label>
                      <md-input  v-model="item.analisa" />
                  
                    </md-field>
                  </div>
                  
                  
                </div>            
              </div>
            </autoextra>
          <md-divider></md-divider>
            <div class="md-layout">
               
                
                  
                
              </div>
          </md-card-content>
        </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';

export default {
  name: "keluhan-card",

 
  props: ['pkb'],
  components: { Autoextra },

  mixins: [formMixin],

  data () {
    return {
      keluhan: [],
    }
  },
  created() {
         // this.onOpen();
      },
   methods:{
    //  async onOpen(){
    //    console.log(this.pkb)
        
    //   },
       
      //fungsi yang dipanggil dari sisi parent untuk mendapatkan value yang ada di page ini
      getData() {
            this.$emit('data', this.keluhan)
        },
        //fungsi yang di panggil dari sisi parent untuk mengset data di page ini, digunakan saat edit
        async getDataParent(data) {
          console.log("keluhan")
          console.log(data)
          data.forEach((value, index) => {
          if( this.$route.name == "Edit PKB"){
              this.$set(this.keluhan, index, {
                  id : value.id,
                  keluhan: value.keluhan,
                  analisa: value.analisa
                });
          }
          else{
              this.$set(this.keluhan, index, {
                  id : value.id,
                  keluhan: value.keluhan,
                  analisa: ""
                });
          }
            
          });

    
        }
        

    },
    mounted() {
        console.log('Component mounted.')

    }
};
</script>

<style>
.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}
</style>
